import React from 'react';
import { Card } from './ui/card';
import { Checkbox } from './ui/checkbox';
import { Label } from './ui/label';
import { Link } from 'react-router-dom';
import { SERVICE_CATALOG } from '../constants/serviceCatalog';
import { useActiveServices } from '../hooks/useActiveServices';

const ServiceSelector = ({ selectedServices, onServiceToggle }) => {
  const { activeServices, loading } = useActiveServices();

  // Filter the canonical catalog by the company's "Services Offered" setting.
  // Default-ON: unknown / missing values render as visible.
  const visibleServices = loading
    ? SERVICE_CATALOG
    : SERVICE_CATALOG.filter((s) => activeServices.includes(s.id));

  if (!loading && visibleServices.length === 0) {
    return (
      <div
        className="rounded-lg border border-dashed border-gray-300 bg-gray-50 p-8 text-center"
        data-testid="service-selector-empty"
      >
        <p className="text-sm font-semibold text-gray-700">No services offered</p>
        <p className="text-xs text-gray-500 mt-1">
          Turn on at least one service in{' '}
          <Link to="/settings/config" className="underline text-primary">
            Settings → App Configuration
          </Link>
          {' '}to use the Calculator.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {visibleServices.map((service) => {
        const Icon = service.icon;
        const isSelected = selectedServices.includes(service.id);
        
        return (
          <Card
            key={service.id}
            data-testid={`calc-service-chip-${service.id}`}
            className={`p-4 cursor-pointer transition-all duration-200 ${
              isSelected
                ? 'bg-secondary/20 border-secondary border-2 shadow-md'
                : 'hover:border-secondary/50 hover:shadow-sm'
            }`}
            onClick={() => onServiceToggle(service.id)}
          >
            <div className="flex items-center gap-3">
              <Checkbox
                id={service.id}
                checked={isSelected}
                onCheckedChange={() => onServiceToggle(service.id)}
                className="data-[state=checked]:bg-secondary data-[state=checked]:border-secondary"
              />
              <Label
                htmlFor={service.id}
                className="flex items-center gap-2 cursor-pointer flex-1"
              >
                <Icon className={`h-5 w-5 ${
                  isSelected ? 'text-secondary' : 'text-muted-foreground'
                }`} />
                <span className={`font-medium ${
                  isSelected ? 'text-secondary' : 'text-foreground'
                }`}>
                  {service.label}
                </span>
              </Label>
            </div>
          </Card>
        );
      })}
    </div>
  );
};

export default ServiceSelector;